import { render } from "./EntityTableEmptyState.vue?vue&type=template&id=36488e33&scoped=true"
import script from "./EntityTableEmptyState.vue?vue&type=script&lang=js"
export * from "./EntityTableEmptyState.vue?vue&type=script&lang=js"

import "./EntityTableEmptyState.vue?vue&type=style&index=0&id=36488e33&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36488e33"]])

export default __exports__